<template>
  <div>
    <p>観光中に立ち寄り先を選択する際に、立ち寄り施設で行っているコロナウイルス感染防止対策を確認することに心がけをしていますか？</p>
    <SelectText :item-list=considerList @select-text="onSelectText" />
  </div>
</template>

<script>
import { CONSIDER_LIST } from '../../const.js'
import SelectText from '@/components/Molecules/SelectText'

export default {
  name: 'input-consider',
  components: {
    SelectText
  },
  computed: {
    considerList () { return CONSIDER_LIST }
  },
  methods: {
    onSelectText (e) {
      this.$emit('select-text', e)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Organisms/InputConsider.vue